import { EditorialTree } from "./types";

export const mockEditorialTree: EditorialTree = {
  problems: [
    {
      level: 1,
      list: [
        "Alto custo de atualização de hardware",
        "Complexidade na escolha de equipamentos que atendam…",
        "Baixa compreensão sobre o impacto tecnológico nas…",
      ],
    },
    {
      level: 2,
      list: [
        "Preocupações com a segurança de dados no uso de…",
        "Sustentabilidade e descarte adequado de equipamentos…",
        "Integração de novos dispositivos na infraestrutura…",
      ],
    },
    {
      level: 3,
      list: [
        "Alto custo inicial de atualização de hardware",
        "Complexidade na escolha de equipamentos que atendam…",
        "Necessidade de tecnologias para trabalho remoto eficaz",
      ],
    },
  ],
  solutions: [
    "Oferecimento de uma linha diversificada de produtos…",
    "Suporte técnico 24/7 que ajuda os consumidores a escolher…",
    "Iniciativas de sustentabilidade que promovem o descarte…",
  ],
  consciousness_level: {
    totally_unconscious: [
      "Clientes não percebem a velocidade de desatualização tecnológica",
      "Muitos não consideram o impacto ambiental dos seus dispositivos",
      "Falta de percepção sobre riscos de segurança com tecnologias antigas",
    ],
    problem_consciousness: [
      "Reconhecimento da necessidade de atualizar dispositivos para…",
    ],
    solution_consciousness: [
      "Conhecimento sobre a disponibilidade de pacotes de suporte…",
    ],
    product_consciousness: ["Consciência dos produtos Dell, incluindo…"],
    brand_consciousness: [
      "Familiaridade com a Dell como uma marca confiável e inovadora…",
    ],
    extremely_consciousness: [
      "Preferência pela Dell baseada em experiências positivas anteriores…",
    ],
  },
  themes_and_subjects: {
    content_categories: [
      {
        title: "Inovação tecnológica",
        topic_list: ["Lançamento de produtos", "Pesquisa..."],
      },
      {
        title: "Sustentabilidade e Meio Ambiente",
        topic_list: ["Produtos ecológicos", "Parcerias verdes"],
      },
      {
        title: "Suporte ao Cliente",
        topic_list: ["Dicas de uso", "Atualizações de software"],
      },
    ],
    specific_topics: [
      "As vantagens das atualizações regulares de hardware",
      "Como a Dell aborda a sustentabilidade nos negócios",
      "Dicas para escolher o laptop ideal para cada perfil de usuário",
    ],
    key_words: [
      "Tecnologia sustentável",
      "Laptops Dell",
      "Suporte técnico Dell",
    ],
  },
};
